import { useState, useEffect } from 'react';

interface UserAvatarProps {
  name: string;
  src?: string | null;
  /** Diameter in pixels. */
  size?: number;
  className?: string;
}

function initials(name: string): string {
  return (name || '')
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

/**
 * Circular user avatar: shows the photo when available, otherwise the user's
 * initials on the brand gradient. Falls back to initials if the image fails.
 */
export default function UserAvatar({ name, src, size = 40, className = '' }: UserAvatarProps) {
  const [errored, setErrored] = useState(false);
  useEffect(() => setErrored(false), [src]);

  const showImage = !!src && !errored;

  return (
    <div
      className={`relative flex shrink-0 items-center justify-center overflow-hidden rounded-full text-white ${className}`}
      style={{
        width: size,
        height: size,
        background: showImage ? undefined : 'var(--gradient-agencium)',
      }}
    >
      {showImage ? (
        <img
          src={src!}
          alt={name}
          className="h-full w-full object-cover"
          onError={() => setErrored(true)}
        />
      ) : (
        <span style={{ fontWeight: 700, fontSize: size * 0.4 }}>{initials(name)}</span>
      )}
    </div>
  );
}
